import { api } from '../config';
import type { 
  MultiPropertySitesResponse, 
  MultiPropertySiteDetailResponse, 
  MultiPropertyUpdateResponse 
} from './types';

// Multi-property API endpoints
const MULTI_PROPERTY_ENDPOINTS = {
  SITES: '/multi-property/sites/',
  SITE_DETAIL: (siteId: string) => `/multi-property/sites/${siteId}`,
} as const;

/**
 * Fetch all multi-property sites
 */
export async function getMultiPropertySites(): Promise<MultiPropertySitesResponse> {
  const response = await api.get(MULTI_PROPERTY_ENDPOINTS.SITES);
  return response;
}

/**
 * Fetch a specific site by ID
 */
export async function getMultiPropertySiteById(siteId: string): Promise<MultiPropertySiteDetailResponse> {
  const response = await api.get(MULTI_PROPERTY_ENDPOINTS.SITE_DETAIL(siteId));
  return response;
}

/**
 * Update a specific site by ID
 */
export async function updateMultiPropertySite(
  siteId: string, 
  updateData: Record<string, any>
): Promise<MultiPropertyUpdateResponse> {
  const response = await api.patch(MULTI_PROPERTY_ENDPOINTS.SITE_DETAIL(siteId), updateData);
  return response;
}